import * as React from 'react';
const Whatsapp = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M49.664 10.229C26.604-12.164-9.572 15.538 6.101 43.616L2.174 57.953l14.673-3.847C44.919 68.948 71.794 32.98 49.664 10.23Z"
      clipRule="evenodd"
    />
    <path
      fill="#66E066"
      fillRule="evenodd"
      d="M30.087 53.247c-4.556.016-8.985-1.352-12.804-3.777l-8.878 2.327 2.37-8.652C8.112 39.198 6.611 34.57 6.631 29.78 6.59 9.05 32.086-1.52 46.68 13.21c14.71 14.605 4.143 40.082-16.592 40.037Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M42.952 35.685c-.705-.353-4.171-2.058-4.818-2.294-.646-.235-1.116-.352-1.586.354-.47.705-1.82 2.293-2.232 2.763-.411.47-.823.53-1.528.177-1.523.203-9.338-6.406-9.592-8.382-.412-.705-.044-1.087.31-1.439.613-.674 1.39-1.521 1.761-2.41.236-.472.118-.883-.058-1.236-.177-.353-1.547-3.84-2.174-5.234-.528-1.174-1.084-1.198-1.587-1.219-1.19.019-2.11-.29-3.231.866-4.203 4.045-2.275 9.729.41 13.173.353.47 4.879 7.817 12.046 10.643 5.956 2.349 7.168 1.882 8.46 1.764 1.294-.118 4.173-1.705 4.76-3.352.587-1.646.587-3.057.412-3.352-.177-.293-.648-.469-1.353-.822Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Whatsapp;
